import { DatePipe } from "@angular/common";
import { Component, EventEmitter, input, Output } from "@angular/core";
import { MinLengthPipe } from "@shared/pipes/minlength.pipe";
import { ClickOutsideDirective } from "ev-directives";
import { FilterOverview } from "src/models/shared/filter.model";

@Component({
    selector: "favorite-list-thumb",
    templateUrl: "./favorite-list-thumb.component.html",
    styleUrl: "./favorite-list-thumb.component.scss",
    imports: [MinLengthPipe, DatePipe, ClickOutsideDirective]
})
export class FavoriteListThumbComponent {
    overview = input<FilterOverview>();
    @Output() onOpenFavorite: EventEmitter<number> = new EventEmitter<number>();
    @Output() onOpenMenu: EventEmitter<number> = new EventEmitter<number>();
    @Output() onCloseMenu: EventEmitter<number> = new EventEmitter<number>();
}
